
export default {
  props: {
    header: {
      default: '',
      type: String,
    },
    id: {
      default: '',
      type: String,
    },
    img: {
      default: '',
      type: String,
    },
    width: {
      default: '90%',
      type: String,
    },
    layout: {
      default: 'left',
      type: String,
    },
    alt: {
      default: '',
      type: String,
    },
    mask: {
      default: '',
      type: String,
    },
    classes: {
      default: '',
      type: String
    },
    subhead: {
      default: '',
      type: String
    },
    blend: {
      default: '',
      type: String
    },
    social: {
      default: '',
      type: String
    },
    youtube: {
      default: '',
      type: String
    },
    linkedin: {
      default: '',
      type: String
    },
    facebook: {
      default: '',
      type: String
    },
    instagram: {
      default: '',
      type: String
    },
    x: {
      default: '',
      type: String
    },
    tiktok: {
      default: '',
      type: String
    },
    blob: {
      default: '',
      type: String,
    },
    bgsize: {
      default: 'cover',
      type: String,
    },
    bgposition: {
      default: '50% 50%',
      type: String,
    },
    imgstyle: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      blobColor: null,
    }
  },
  mounted() {
    this.randomizeDiacritics();
  },
  methods: {
    bgImage(thumbnail) {
      // console.log('THUMBNAIL',thumbnail)
      const dotIndex = thumbnail.lastIndexOf('.');
      const ext = thumbnail.substring(dotIndex);
      const options = {quality:60, width: '700px'}
      if (ext === '.jpg' || ext === '.JPG' || ext === '.jpeg' || ext === '.JPEG' || ext === '.png' || ext === '.PNG' ){
        options.format = 'webp'
      }
      console.log('THUMBNAIL',thumbnail,options)
      const imgUrl = this.$img(this.$options.filters.cdn(thumbnail), options)
      return imgUrl
    },
    // For blob mask
    getRandomPercentage() {
          return Math.floor(Math.random() * 61) + 40; // Random number between 0 and 100
        },
        generateSection() {
          let section = '';
          for (let i = 0; i < 4; i++) {
            section += this.getRandomPercentage() + '%';
            if (i < 3) {
              section += ' ';
            }
          }
          return section;
        },
        getRandomBlob() {
          if(this.$props.blob === 'yellow'){
            this.blobColor = '#FFFCF0'
          }
          if(this.$props.blob === 'pink'){
            this.blobColor = '#FFF0F7'
          }
          if(this.$props.blob === 'blue'){
            this.blobColor = '#F0FAFF'
          }
          if(this.$props.blob === 'green'){
            this.blobColor = '#F0FFF6'
          }
          if(this.$props.blob === 'purple'){
            this.blobColor = '#F9F0FF'
          }
          console.log('blob', this.$props.blob)
          console.log('blobColor', this.blobColor)
          return this.generateSection() + '/' + this.generateSection();
        },
        randomizeDiacritics() {
          const diacritics = document.querySelectorAll('.diacritic');
          diacritics.forEach(diacritic => {
            let randomX = 0;
            let randomY = 0;
            const randomRotation = Math.floor(Math.random() * 61) - 30; // Random value between -10 and 10

            // Check for specific classes and adjust translations
            if (diacritic.classList.contains('left-0')) {
              randomX = Math.floor(Math.random() * 21); // Random value between 0 and 30 (only to the right)
            } else if (diacritic.classList.contains('right-0')) {
              randomX = Math.floor(Math.random() * 21) * -1; // Random value between -30 and 0 (only to the left)
            }

            if (diacritic.classList.contains('top-0')) {
              randomY = Math.floor(Math.random() * 21); // Random value between 0 and 30 (only down)
            } else if (diacritic.classList.contains('bottom-0')) {
              randomY = Math.floor(Math.random() * 21) * -1; // Random value between -30 and 0 (only up)
            }

            // Apply random opacity with a 33% chance to hide the diacritic
            const randomOpacity = Math.random() < 0.33 ? 0 : 1; // 0 for hidden, or a random opacity between 0 and 1
            diacritic.style.opacity = randomOpacity;

            // Apply the transform
            diacritic.style.transform = `translate(${randomX}px, ${randomY}px) rotate(${randomRotation}deg)`;
        });
        },
  },
  render() {
    const slot = this.$slots.default
    //  return slot.text.replace(/,/g, "")
    return slot
  },
}
